import * as sonbp from "sonbp";
import * as ifbase from "../../base";
import * as editor from "./index";

export function init(ifdto: ifbase.ifDto, func:(event: sonbp.type.event) => void): void {

	//// [sonbp] ムーブエディター(移動・リサイズ・回転) 作成
	//ifdto.bpMoveEditor = new editor.poscaMoveEditor(ifdto);
	//ifdto.bpMoveEditor.onEditStateFunc(func);

	// [sonbp] 画像枠（クリップイメージ）エディター 作成
	ifdto.bpClipImageEditor = new editor.poscaClipImageEditor(ifdto);
	ifdto.bpClipImageEditor.onEditStateFunc(func);
	ifdto.bpClipImageEditor.actionModeForMTouch = 2;

	// [sonbp] スタンプエディター 作成
	ifdto.bpStampEditor = new editor.poscaStampEditor(ifdto);
	ifdto.bpStampEditor.onEditStateFunc(func);
	ifdto.bpStampEditor.actionModeForMTouch = 2;

	// [sonbp] テキストエディター 作成
	ifdto.bpTextEditor = new editor.poscaTextEditor(ifdto);
	ifdto.bpTextEditor.onEditStateFunc(func);
	ifdto.bpTextEditor.actionModeForMTouch = 2;
}
